import React, {Component} from "react";
import {connect} from "react-redux";
import Table from "../../../components/Table";
import WaterPalletItem from "./WaterPalletItem";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import PaginatorButton from "../../../components/PaginatorButton";
import {fromJS, List} from "immutable";
import {graphql} from "react-apollo";
import {LIST_WATER_PALLETS_WITH_FILTER, ON_NEW_WATER_PALLET, ON_UPDATED_WATER_PALLET} from "../../../queries/inventory";
import update from "immutability-helper";

class WaterPalletsList extends Component {

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.updateSubscription && !nextProps.loading) {
      this.updateSubscription = this.props.subscribeToUpdates(this.props);
    }
    if (!this.newDataSubscription && !nextProps.loading) {
      this.newDataSubscription = this.props.subscribeToNewData(this.props);
    }
  }

  render() {
    let {loading, error, waterPallets} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />

    let tableHeader = List([
      "Pallet ID",
      "SKU",
      "State",
      "Items",
    ]);

    return (
      <div>
        <Table
          data={fromJS(waterPallets.entries)}
          tableHeader={tableHeader}
          renderer={WaterPalletItem}
          selected={this.props.selectedPalletId}
          onItemClick={this.handleItemClick.bind(this)}
          showCount={true}
          itemKey="palletId"
          mode="table"/>
        <PaginatorButton 
          metadata={fromJS(waterPallets.metadata)} 
          onNext={this.handleNext.bind(this)}
          />
      </div>
    )
  }

  handleNext(afterId) {
    this.props.data.fetchMore({
      variables: {
        pagination: {
          after: afterId
        }
      },
      updateQuery: (prev, {fetchMoreResult}) => {
        if (!fetchMoreResult) return prev;
        return {
          waterPallets: {
            __typename: prev.waterPallets.__typename,
            metadata: fetchMoreResult.waterPallets.metadata,
            entries: [...prev.waterPallets.entries, ...fetchMoreResult.waterPallets.entries]
          }
        }
      }
    })
  }  


  handleItemClick(itemData, e, field = "") {
    let palletId = itemData.get("palletId");
    if (field === "id") {
      e.stopPropagation();
      this.props.onPalletIdClick(palletId);
      return;
    }
    this.props.onSelectionChange(palletId);
  }
}


const mapDispatchToProps = dispatch => ({
  subscribeToNewData: (props, params) => {
    return props.data.subscribeToMore({
      document: ON_NEW_WATER_PALLET,
      updateQuery: (prev, { subscriptionData }) => {
        if (!subscriptionData.data) {
          return prev;
        }
        return update(prev, {
          waterPallets: {
            entries: {
              $unshift: [subscriptionData.data.newWaterPallet]
            }
          }
        })
      }
    })
  },
  subscribeToUpdates: (props, params) => {
    return props.data.subscribeToMore({
      document: ON_UPDATED_WATER_PALLET,
      updateQuery: (prev, { subscriptionData }) => {
        return prev;
      }
    })
  }  
})

const withSubscription = connect(null, mapDispatchToProps);

const withQuery = graphql(LIST_WATER_PALLETS_WITH_FILTER, {
  options: (props) => ({
    fetchPolicy: "network-only",
    variables: {
      filter: {
        sku: props.skuFilter
      }
    }
  })
})

export default withQuery(withSubscription(WaterPalletsList));